module.exports = __webpack_public_path__ + "img/pica1.e0ad2ef9.png";